<table class="imc-table">
  <thead> <!-- class="text-menu-title-selected" -->
  <tr>
    <th rowspan="2" class="tw-align-bottom">Grado</th>
    <th rowspan="2" class="tw-align-bottom">IMC</th>
    <th [class.selected]="metadata.gender === genderEnum.MALE">Varones</th>
    <th [class.selected]="headerActive === 0 && metadata.gender === genderEnum.MALE">< 0.85</th>
    <th [class.selected]="headerActive === 1 && metadata.gender === genderEnum.MALE">0.85 - 1.0</th>
    <th [class.selected]="headerActive === 2 && metadata.gender === genderEnum.MALE">> 1.0</th>
  </tr>
  <tr>
    <th [class.selected]="metadata.gender === genderEnum.FEMALE">Mujeres</th>
    <th [class.selected]="headerActive === 0 && metadata.gender === genderEnum.FEMALE">< 0.70</th>
    <th [class.selected]="headerActive === 1 && metadata.gender === genderEnum.FEMALE">0.70 - 0.85</th>
    <th [class.selected]="headerActive === 2 && metadata.gender === genderEnum.FEMALE">> 0.85</th>
  </tr>
  </thead>
  <tbody>
  <tr>
    <td class="text-center" [class.selected]="metadata.grade === 0">0</td>
    <td class="text-center" [class.selected]="metadata.grade === 0">20.0 - 24.9</td>
    <td rowspan="5"></td>
    <td [class.selected]="metadata.grade === 0 && headerActive === 0">Muy leve</td>
    <td [class.selected]="metadata.grade === 0 && headerActive === 1">Leve</td>
    <td [class.selected]="metadata.grade === 0 && headerActive === 2">Moderado</td>
  </tr>
  <tr>
    <td class="text-center" [class.selected]="metadata.grade === 1">1</td>
    <td class="text-center" [class.selected]="metadata.grade === 1">25.0 - 29.9</td>
    <td [class.selected]="metadata.grade === 1 && headerActive === 0">Leve</td>
    <td [class.selected]="metadata.grade === 1 && headerActive === 1">Moderado</td>
    <td [class.selected]="metadata.grade === 1 && headerActive === 2">Alto</td>
  </tr>
  <tr>
    <td class="text-center" [class.selected]="metadata.grade === 2">2</td>
    <td class="text-center" [class.selected]="metadata.grade === 2">30.0 - 34.9</td>
    <td [class.selected]="metadata.grade === 2 && headerActive === 0">Moderado</td>
    <td [class.selected]="metadata.grade === 2 && headerActive === 1">Alto</td>
    <td [class.selected]="metadata.grade === 2 && headerActive === 2">Muy alto</td>
  </tr>
  <tr>
    <td class="text-center" [class.selected]="metadata.grade === 3">3</td>
    <td class="text-center" [class.selected]="metadata.grade === 3">35.0 - 39.9</td>
    <td [class.selected]="metadata.grade === 3 && headerActive === 0">Alto</td>
    <td [class.selected]="metadata.grade === 3 && headerActive === 1">Muy alto</td>
    <td [class.selected]="metadata.grade === 3 && headerActive === 2">Muy alto</td>
  </tr>
  <tr>
    <td class="text-center" [class.selected]="metadata.grade === 4">4</td>
    <td class="text-center" [class.selected]="metadata.grade === 4">≥ 40.0</td>
    <td [class.selected]="metadata.grade === 4 && headerActive === 0">Muy alto</td>
    <td [class.selected]="metadata.grade === 4 && headerActive === 1">Muy alto</td>
    <td [class.selected]="metadata.grade === 4 && headerActive === 2">Muy alto</td>
  </tr>
  </tbody>
</table>
